import React, { useState, useEffect, useRef } from "react";

export function useLazyImage(src) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setImgSrc(src);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }, // start loading 200px before it enters view
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [src]);

  return { ref, imgSrc, loaded, setLoaded, error, setError };
}

export default function LazyPhoto({ photo, imgErrors, setImgErrors }) {
  const primarySrc = imgErrors[photo.id]
    ? `https://drive.google.com/uc?export=view&id=${photo.drive_file_id}`
    : photo.thumbnail_url;

  const { ref, imgSrc, loaded, setLoaded } = useLazyImage(primarySrc);

  return (
    <div
      ref={ref}
      className="w-full bg-gray-100 dark:bg-gray-800 min-h-[120px]"
    >
      {imgSrc && (
        <img
          src={imgSrc}
          alt={photo.filename}
          className={`w-full h-auto object-cover transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
          onLoad={() => setLoaded(true)}
          onError={() => {
            if (!imgErrors[photo.id]) {
              setImgErrors((prev) => ({ ...prev, [photo.id]: true }));
            }
          }}
        />
      )}
    </div>
  );
}
